export default __webpack_public_path__ + "static/media/slide4_m_bg.3e24a6e4.png";